<template>
  <div class="ml-auto whitespace-nowrap md:mt-ds-xxs">
    <PhoneNumber
      :class="$style.fullNumber"
      :show-icon="true"
      :show-text="true"
      :handle-click="
        () => handleCalUsClick(getPhoneNumberValue.baseRaw, getPhoneNumberValue.extension)
      "
    />
    <PhoneNumber
      class="md:hidden"
      :show-button="true"
      :show-button-text="true"
      :handle-click="
        () => handleCalUsClick(getPhoneNumberValue.baseRaw, getPhoneNumberValue.extension)
      "
      :button-text="$t('navigation.call_us')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import { GET_PHONE_NUMBER_VALUE } from "~/store/phone-number"

export default defineComponent({
  name: "NavCallUs",
  computed: {
    ...mapGetters("phone-number", {
      getPhoneNumberValue: GET_PHONE_NUMBER_VALUE
    })
  },
  methods: {
    handleCalUsClick(phoneNumber: string, extension?: string) {
      this.$snowplow.trackCallUs({
        phoneNumber,
        label: "navigation_button",
        action: "click",
        extension
      })
      this.$emit("hide-other-menus")
    }
  }
})
</script>

<style lang="css" module>
.fullNumber {
  @apply hidden md:block font-bold no-underline hover:no-underline;

  a {
    @apply no-underline hover:no-underline hover:text-white;
  }
}
</style>
